import React from 'react';
import PropTypes from 'prop-types';
import { css, cx } from '@bd/bdui-styles/emotion';
import { Image } from '@bd/bdcore-utilities';

const wrapperStyles = css`
  position: relative;
  overflow: hidden;
  @supports (object-fit: cover) and (object-position: center center) {
    position: static;
  }
`;

const imageStyles = css`
  position: absolute;
  top: -100%;
  right: -100%;
  bottom: -100%;
  left: -100%;
  min-width: 100%;
  min-height: 100%;
  margin: auto;
  @supports (object-fit: cover) and (object-position: center center) {
    position: static;
    min-width: 0;
    min-height: 0;
    margin: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
  }
`;

function ImageWrapper({ alt, className, height, imgClassName, src, width }) {
  return (
    <div className={cx(wrapperStyles, className)}>
      <Image
        className={cx(imageStyles, imgClassName)}
        src={src}
        alt={alt}
        width={width}
        height={height}
      />
    </div>
  );
}

ImageWrapper.propTypes = {
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
  height: PropTypes.number,
  imgClassName: PropTypes.string,
  src: PropTypes.string.isRequired,
  width: PropTypes.number,
};

ImageWrapper.defaultProps = {
  className: 'ImageWrapper_wrapper',
  height: 600,
  imgClassName: '',
  width: 600,
};

export default ImageWrapper;



// WEBPACK FOOTER //
// ./src/components/ImageWrapper.js